import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import GlobalStyle from '../../styles/global';
import theme from '../../styles/theme';
import SEO from './seo';
import NavMenu from '../nav';
import MobileNav from '../mobile-nav';
import Footer from '../footer';
import { useStaticQuery, graphql } from 'gatsby';

const StyledPage = styled.div`
	&.home {
		.navbar {
			.inner {
				.brand {
					img {
						@media (min-width: 769px) {
							width: 150px;
						}
					}
				}
			}
		}
		.hero {
			.text-container {
				@media all and (max-width: ${(p) => p.theme.burgerBreakpoint}) {
					margin-top: 2rem;
				}
			}
		}
	}
`;

const Page = ({ children, title, page }) => {
	const { settings } = useStaticQuery(
		graphql`
			{
				settings: settingsJson {
					cancellations {
						text
						showText
						link
					}
				}
			}
		`
	);

	const [navIsOpen, setNavOpen] = useState(false);
	const [locationsIsOpen, setLocationsOpen] = useState(false);
	const [lessonsIsOpen, setLessonsOpen] = useState(false);

	return (
		<ThemeProvider theme={theme}>
			<>
				<GlobalStyle />
				<SEO title={title} />
				<MobileNav
					cancellations={settings.cancellations.showText}
					state={{
						navIsOpen,
						setNavOpen,
						locationsIsOpen,
						setLocationsOpen,
						lessonsIsOpen,
						setLessonsOpen,
					}}
				/>
				<StyledPage className={page}>
					<NavMenu
						mobileOpen={navIsOpen || locationsIsOpen || lessonsIsOpen}
						cancellations={settings.cancellations}
					/>
					{children}
					<Footer />
				</StyledPage>
			</>
		</ThemeProvider>
	);
};

export default Page;
